// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from './js/actions';

import SessionTimeoutWarning from 'components/Dialog/SessionTimeoutWarning';
import LoginDialogJS from 'components/Dialog/LoginDialog';

interface ReduxStateProps {
    loginDialogOpen: any;
}

interface ReduxActionProps {
    getAuthStatus: any;
    closeLoginDialog: any;
}

interface ComponentProps {
    idleMonitor?: any;
}

interface ComponentState {
    shouldShowSessionTimeoutWarning: boolean;
}

// tslint:disable
const LoginDialogTS: any = LoginDialogJS;
const SessionTimeoutWarningTS: any = SessionTimeoutWarning;
// tslint:enable

class AuthProvider extends React.Component<
    ComponentProps & ReduxActionProps & ReduxStateProps,
    ComponentState
> {
    constructor(props) {
        super(props);

        this.state = {
            shouldShowSessionTimeoutWarning: false,
        };
    }

    // public static defaultProps: Partial<ComponentProps> = {
    //     idleMonitor: null,
    // };

    handleCloseLoginDialog = () => {
        this.props.closeLoginDialog();
    };

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.idleMonitor.idleStatus !==
            this.props.idleMonitor.idleStatus
        ) {
            // console.log('CHANGE IN USER ACTIVITY STATUS IDL', this.props.idleMonitor.idleStatus);
            if (this.props.idleMonitor.idleStatus === 'INACTIVE') {
                this.setState(
                    {
                        shouldShowSessionTimeoutWarning: true,
                    },
                    () => {
                        // console.log('SHOULD SHOW DIALOG')
                    },
                );
            }
        }
    }

    handleCloseSessionTimeoutWarning = () => {
        this.setState({
            shouldShowSessionTimeoutWarning: false,
        });
    };

    render() {
        this.props.getAuthStatus();
        // console.log('idleMonitor', this.props.idleMonitor);

        return (
            <React.Fragment>
                {this.state.shouldShowSessionTimeoutWarning && (
                    <SessionTimeoutWarningTS
                        modal={false}
                        open={this.state.shouldShowSessionTimeoutWarning}
                        onClose={this.handleCloseSessionTimeoutWarning}
                    />
                )}
                <LoginDialogTS
                    modal={false}
                    open={this.props.loginDialogOpen}
                    handleClose={this.handleCloseLoginDialog}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = ({ auth, client }) => ({
    loginDialogOpen: auth.loginDialogOpen,
});

export default connect<ReduxStateProps, ReduxActionProps, ComponentProps>(
    mapStateToProps,
    actions,
)(AuthProvider);



// WEBPACK FOOTER //
// ./src/AuthProvider.tsx